const backendBaseUri = `https://backendimplant.thetibergroup.com`;

export { backendBaseUri };



// WEBPACK FOOTER //
// ./src/uri.js